import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { AvailableWidgets } from "../AvailableWidgets";

import {
  DatasetsWrapper,
  DatasetsHeading,
  DatasetsHeadingWrapper,
  DatasetsSection,
} from "./styles";
import { DatasetsItem } from "../DatasetsItem";
import { requestGetAllDatasets } from "../../store/slices/datasets";
import { getCurrentProjectData } from "../../store/selectors/projects";

export const DatavizRecommendedWidgets = ({
  setSelectedChart,
}: {
  setSelectedChart: (chart?: string) => void;
}) => {
  const dispatch = useDispatch();
  const { datasets } = useSelector(getCurrentProjectData);

  useEffect(() => {
    dispatch(requestGetAllDatasets({}));
  }, [dispatch]);

  return (
    <>
      <DatasetsSection>
        <DatasetsHeadingWrapper>
          <DatasetsHeading>Parameters</DatasetsHeading>
          {/* <Button
            name={
              currentWidget && currentWidget.id ? "Switch dataset" : "Add more"
            }
            onClick={() =>
              dispatch(
                setActiveModal({ id: "datasetLibraryModal", back: false })
              )
            }
            variant="primary"
            icon={
              currentWidget && currentWidget.id ? (
                <LayersHalf />
              ) : (
                <PlusCircle />
              )
            }
            size="small"
          /> */}
        </DatasetsHeadingWrapper>
        <DatasetsWrapper>
          {datasets.map((dataset) => {
            return (
              <DatasetsItem
                // selectedDimensions={currentKeys}
                dataset={dataset}
                key={dataset.filePath}
                disablePreview
              />
            );
          })}
        </DatasetsWrapper>
      </DatasetsSection>
      <AvailableWidgets selectChart={setSelectedChart} />
    </>
  );
};
